var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[(_vm.noContractsSelected)?_c('b-alert',{attrs:{"dismissible":"","show":"","variant":"danger"}},[_c('h6',[_vm._v("Verträge auswählen")]),_c('p',[_vm._v("Keine Verträge zum Vergleichen ausgewählt.")])]):_vm._e(),(_vm.isLoading)?_c('u-loader'):(_vm.ContractOne && _vm.ContractTwo)?_c('div',[(_vm.storedPdf)?_c('button',{staticClass:"d-block",on:{"click":function($event){_vm.storedPdf.download(
          `${_vm.ContractOne.EditionInfo.id.toString()}_${_vm.ContractTwo.EditionInfo.id.toString()}_${_vm.$moment(
            new Date(),
          ).format('YYYYMMDD')}.pdf`,
        )}}},[_c('i',{staticClass:"fas fa-file-pdf"}),_vm._v(" Vergleich als PDF speichern\n    ")]):_vm._e(),(_vm.storedPdf)?_c('button',{staticClass:"d-block",on:{"click":function($event){_vm.downloadCsv(
          `${_vm.ContractOne.EditionInfo.id.toString()}_${_vm.ContractTwo.EditionInfo.id.toString()}_${_vm.$moment(
            new Date(),
          ).format('YYYYMMDD')}.csv`,
        )}}},[_c('i',{staticClass:"fas fa-file-csv"}),_vm._v(" Vergleich als CSV speichern\n    ")]):_vm._e(),_c('div',{staticClass:"w-100"},[(_vm.storedPdf)?_c('v-select',{staticClass:"w-25 mb-4 float-right",attrs:{"items":_vm.languages,"item-text":"label","item-value":"language"},model:{value:(_vm.selectedLanguage),callback:function ($$v) {_vm.selectedLanguage=$$v},expression:"selectedLanguage"}}):_c('div',{staticClass:"float-right small"},[_vm._v("\n        Sprache kann erst geändert werden sobal alle Kriterien geladen sind\n      ")])],1),_c('table',{key:_vm.selectedLanguage,staticClass:"table comparisonTable"},[_c('thead',[_c('tr',[_c('td',[_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"switchSymbol",attrs:{"placement":"bottom","title":"Verträge vertauschen","type":"button"},on:{"click":function($event){return _vm.switchContracts()}}},[_c('i',{staticClass:"fas fa-exchange-alt"})])]),_c('td',[_c('router-link',{attrs:{"to":'/contract-overview/' +
                  _vm.ContractOne.ContractInfo.contractNumber +
                  '/' +
                  _vm.ContractOne.VersionInfo.number}},[_vm._v("\n              "+_vm._s(_vm.getContentByLanguage(
                  _vm.ContractOne.VersionInfo.versionContents,
                  "nameShort",
                  _vm.selectedLanguage,
                  true,
                ))+"\n            ")])],1),_c('td',[_c('router-link',{attrs:{"to":'/contract-overview/' +
                  _vm.ContractTwo.ContractInfo.contractNumber +
                  '/' +
                  _vm.ContractTwo.VersionInfo.number}},[_vm._v("\n              "+_vm._s(_vm.getContentByLanguage(
                  _vm.ContractTwo.VersionInfo.versionContents,
                  "nameShort",
                  _vm.selectedLanguage,
                  true,
                ))+"\n            ")])],1),_c('td',[_vm._v("Vergleich")])])]),_c('tbody',[_c('ComparableTableRow',{attrs:{"order":1,"text1":_vm.getContentByLanguage(
              _vm.ContractOne.VersionInfo.versionContents,
              'value',
              _vm.selectedLanguage,
              false,
            ),"text2":_vm.getContentByLanguage(
              _vm.ContractTwo.VersionInfo.versionContents,
              'value',
              _vm.selectedLanguage,
              false,
            ),"title":"Name"},on:{"comparisonFinished":(comparison) => {
              _vm.addComparison(comparison);
            }}}),_c('ComparableTableRow',{attrs:{"order":2,"text1":_vm.getContentByLanguage(
              _vm.ContractOne.VersionInfo.versionContents,
              'nameShort',
              _vm.selectedLanguage,
              false,
            ),"text2":_vm.getContentByLanguage(
              _vm.ContractTwo.VersionInfo.versionContents,
              'nameShort',
              _vm.selectedLanguage,
              false,
            ),"title":"Kurzname"},on:{"comparisonFinished":(comparison) => {
              _vm.addComparison(comparison);
            }}}),_c('ComparableTableRow',{attrs:{"order":3,"text1":_vm.ContractOne.ContractInfo.contractNumber,"text2":_vm.ContractTwo.ContractInfo.contractNumber,"title":"Vertragsnummer"},on:{"comparisonFinished":(comparison) => {
              _vm.addComparison(comparison);
            }}}),_c('ComparableTableRow',{attrs:{"order":4,"text1":_vm.ContractOne.VersionInfo.number.toString(),"text2":_vm.ContractTwo.VersionInfo.number.toString(),"title":"Version"},on:{"comparisonFinished":(comparison) => {
              _vm.addComparison(comparison);
            }}}),(
            (_vm.ContractOne.VersionInfo.ave &&
              (_vm.ContractOne.VersionInfo.ave.aveStart ||
              _vm.ContractOne.VersionInfo.ave.aveEnd ||
              _vm.ContractOne.VersionInfo.ave.ablaufdatum)) ||
              (_vm.ContractTwo.VersionInfo.ave &&
              (_vm.ContractTwo.VersionInfo.ave.aveStart ||
              _vm.ContractTwo.VersionInfo.ave.aveEnd ||
              _vm.ContractTwo.VersionInfo.ave.ablaufdatum))
          )?[_c('ComparableTableRow',{attrs:{"text1":_vm.ContractOne.VersionInfo.ave &&
                (_vm.ContractOne.VersionInfo.ave.aveStart ||
                _vm.ContractOne.VersionInfo.ave.aveEnd ||
                _vm.ContractOne.VersionInfo.ave.ablaufdatum)
                ? 'Ja'
                : 'Nein',"text2":_vm.ContractTwo.VersionInfo.ave &&
                (_vm.ContractTwo.VersionInfo.ave.aveStart ||
                _vm.ContractTwo.VersionInfo.ave.aveEnd ||
                _vm.ContractTwo.VersionInfo.ave.ablaufdatum)
                ? 'Ja'
                : 'Nein',"title":"AVE"}}),(_vm.aveStatus.length != 0)?_c('ComparableTableRow',{attrs:{"order":12,"text1":_vm.aveStatus[_vm.ContractOne.VersionInfo.ave.aveState],"text2":_vm.aveStatus[_vm.ContractTwo.VersionInfo.ave.aveState],"title":"AVE-Status"},on:{"comparisonFinished":(comparison) => {
                _vm.addComparison(comparison);
              }}}):_vm._e(),_c('ComparableTableRow',{attrs:{"order":15,"text1":_vm.ContractOne.VersionInfo.ave &&
                _vm.ContractOne.VersionInfo.ave.aveStart
                ? _vm.formatDate(_vm.ContractOne.VersionInfo.ave.aveStart)
                : '',"text2":_vm.ContractTwo.VersionInfo.ave &&
                _vm.ContractTwo.VersionInfo.ave.aveStart
                ? _vm.formatDate(_vm.ContractTwo.VersionInfo.ave.aveStart)
                : '',"title":"AVE Änderungen gültig ab"},on:{"comparisonFinished":(comparison) => {
                _vm.addComparison(comparison);
              }}}),_c('ComparableTableRow',{attrs:{"order":16,"text1":_vm.ContractOne.VersionInfo.ave &&
                _vm.ContractOne.VersionInfo.ave.aveEnd
                ? _vm.formatDate(_vm.ContractOne.VersionInfo.ave.aveEnd)
                : '',"text2":_vm.ContractTwo.VersionInfo.ave &&
                _vm.ContractTwo.VersionInfo.ave.aveEnd
                ? _vm.formatDate(_vm.ContractTwo.VersionInfo.ave.aveEnd)
                : '',"title":"AVE Änderungen gültig bis"},on:{"comparisonFinished":(comparison) => {
                _vm.addComparison(comparison);
              }}}),_c('ComparableTableRow',{attrs:{"order":17,"text1":_vm.ContractOne.VersionInfo.ave &&
                _vm.ContractOne.VersionInfo.ave.ablaufdatum
                ? _vm.formatDate(_vm.ContractOne.VersionInfo.ave.ablaufdatum)
                : '',"text2":_vm.ContractTwo.VersionInfo.ave &&
                _vm.ContractTwo.VersionInfo.ave.ablaufdatum
                ? _vm.formatDate(_vm.ContractTwo.VersionInfo.ave.ablaufdatum)
                : '',"title":"Künstliche Verlängerung bis"},on:{"comparisonFinished":(comparison) => {
                _vm.addComparison(comparison);
              }}})]:[_c('ComparableTableRow',{attrs:{"order":18,"text1":"Nein","text2":"Nein","title":"AVE"},on:{"comparisonFinished":(comparison) => {
                _vm.addComparison(comparison);
              }}})],_c('ComparableTableRow',{attrs:{"order":19,"text1":_vm.ContractOne.VersionInfo.anhang1 ? 'Ja' : 'Nein',"text2":_vm.ContractTwo.VersionInfo.anhang1 ? 'Ja' : 'Nein',"title":"Anhang 1"},on:{"comparisonFinished":(comparison) => {
              _vm.addComparison(comparison);
            }}}),(
            _vm.ContractOne.VersionInfo.anhang1 || _vm.ContractTwo.VersionInfo.anhang1
          )?_c('ComparableTableRow',{attrs:{"order":19,"text1":_vm.ContractOne.VersionInfo.anhang1ExtendedUntil
              ? _vm.formatDate(_vm.ContractOne.VersionInfo.anhang1ExtendedUntil)
              : '',"text2":_vm.ContractTwo.VersionInfo.anhang1ExtendedUntil
              ? _vm.formatDate(_vm.ContractTwo.VersionInfo.anhang1ExtendedUntil)
              : '',"title":"Anhang 1 bis"},on:{"comparisonFinished":(comparison) => {
              _vm.addComparison(comparison);
            }}}):_vm._e(),_c('ComparableTableRow',{attrs:{"order":5,"text1":_vm.ContractOne.EditionInfo.id.toString(),"text2":_vm.ContractTwo.EditionInfo.id.toString(),"title":"Edition"},on:{"comparisonFinished":(comparison) => {
              _vm.addComparison(comparison);
            }}}),_c('ComparableTableRow',{attrs:{"order":6,"text1":_vm.ContractOne.ContractInfo.contractLanguage,"text2":_vm.ContractTwo.ContractInfo.contractLanguage,"title":"Originalsprache"},on:{"comparisonFinished":(comparison) => {
              _vm.addComparison(comparison);
            }}}),(_vm.contractTypes.length != 0)?_c('ComparableTableRow',{attrs:{"order":7,"text1":_vm.getContractTypeName(_vm.ContractOne.ContractInfo.contractTypeId),"text2":_vm.getContractTypeName(_vm.ContractTwo.ContractInfo.contractTypeId),"title":"Vertragstyp"},on:{"comparisonFinished":(comparison) => {
              _vm.addComparison(comparison);
            }}}):_vm._e(),_c('ComparableTableRow',{attrs:{"order":8,"text1":_vm.ContractOne.ContractInfo.contractResponsible,"text2":_vm.ContractTwo.ContractInfo.contractResponsible,"title":"Verantwortlicher"},on:{"comparisonFinished":(comparison) => {
              _vm.addComparison(comparison);
            }}}),(
            _vm.getContractValue(
              _vm.ContractOne,
              'ContractInfo.companiesUnderContract',
            ) ||
              _vm.getContractValue(
                _vm.ContractTwo,
                'ContractInfo.companiesUnderContract',
              )
          )?_c('ComparableTableRow',{attrs:{"order":9,"text1":_vm.CreateTextForYearValue(
              _vm.getContractValue(
                _vm.ContractOne,
                'ContractInfo.companiesUnderContract',
              ),
            ),"text2":_vm.CreateTextForYearValue(
              _vm.getContractValue(
                _vm.ContractTwo,
                'ContractInfo.companiesUnderContract',
              ),
            ),"title":"Anzahl unterstellter Betriebe"},on:{"comparisonFinished":(comparison) => {
              _vm.addComparison(comparison);
            }}}):_vm._e(),(
            _vm.ContractOne.ContractInfo.employeesUnderContract ||
              _vm.ContractTwo.ContractInfo.employeesUnderContract
          )?_c('ComparableTableRow',{attrs:{"order":10,"text1":_vm.CreateTextForYearValue(
              _vm.ContractOne.ContractInfo.employeesUnderContract,
            ),"text2":_vm.CreateTextForYearValue(
              _vm.ContractTwo.ContractInfo.employeesUnderContract,
            ),"title":"Anzahl unterstellter ArbeitnehmerInnen"},on:{"comparisonFinished":(comparison) => {
              _vm.addComparison(comparison);
            }}}):_vm._e(),_c('ComparableTableRow',{attrs:{"order":13,"text1":_vm.formatDate(_vm.ContractOne.VersionInfo.validFrom),"text2":_vm.formatDate(_vm.ContractTwo.VersionInfo.validFrom),"title":"Änderung gültig ab"},on:{"comparisonFinished":(comparison) => {
              _vm.addComparison(comparison);
            }}}),_c('ComparableTableRow',{attrs:{"order":14,"text1":_vm.formatDate(_vm.ContractOne.VersionInfo.validTo),"text2":_vm.formatDate(_vm.ContractTwo.VersionInfo.validTo),"title":"Änderung gültig bis"},on:{"comparisonFinished":(comparison) => {
              _vm.addComparison(comparison);
            }}}),_c('ComparableTableRow',{attrs:{"order":20,"text1":_vm.ContractOne.EditionInfo.vertragsdatenVisible ? 'Ja' : 'Nein',"text2":_vm.ContractTwo.EditionInfo.vertragsdatenVisible ? 'Ja' : 'Nein',"title":"GAV-Details anzeigen"},on:{"comparisonFinished":(comparison) => {
              _vm.addComparison(comparison);
            }}}),_c('ComparableTableRow',{attrs:{"order":21,"text1":_vm.ContractOne.EditionInfo.lohnrechnerVisible ? 'Ja' : 'Nein',"text2":_vm.ContractTwo.EditionInfo.lohnrechnerVisible ? 'Ja' : 'Nein',"title":"Lohnrechner anzeigen"},on:{"comparisonFinished":(comparison) => {
              _vm.addComparison(comparison);
            }}}),_c('ComparableTableRow',{attrs:{"order":22,"text1":_vm.ContractOne.EditionInfo.uelVisible ? 'Ja' : 'Nein',"text2":_vm.ContractTwo.EditionInfo.uelVisible ? 'Ja' : 'Nein',"title":"Üblicher Lohn anzeigen"},on:{"comparisonFinished":(comparison) => {
              _vm.addComparison(comparison);
            }}}),_c('ComparableTableRow',{attrs:{"order":23,"text1":_vm.ContractOne.EditionInfo.komentar,"text2":_vm.ContractTwo.EditionInfo.komentar,"title":"Kommentar zur Edition"},on:{"comparisonFinished":(comparison) => {
              _vm.addComparison(comparison);
            }}}),_c('ComparableTableRow',{staticClass:"newSection",attrs:{"order":24,"text1":_vm.CreateTextForNogaBranches(
              _vm.ContractOne.nogaBranches,
              _vm.ContractTwo.nogaBranches,
            ),"text2":_vm.CreateTextForNogaBranches(
              _vm.ContractTwo.nogaBranches,
              _vm.ContractOne.nogaBranches,
            ),"title":"Noga-Branchen"},on:{"comparisonFinished":(comparison) => {
              _vm.addComparison(comparison);
            }}}),_c('ComparableTableRow',{staticClass:"newSection",attrs:{"order":25,"text1":_vm.ContractOne.cantons,"text2":_vm.ContractTwo.cantons,"title":"Kantone"},on:{"comparisonFinished":(comparison) => {
              _vm.addComparison(comparison);
            }}}),_vm._l((_vm.tenants),function(tenant,index){return [(
              _vm.hasPublicationData(_vm.ContractOne.PublicationInfo, tenant.id) ||
                _vm.hasPublicationData(_vm.ContractTwo.PublicationInfo, tenant.id)
            )?[_c('tr',{key:index + '_' + tenant.id + '_section',staticClass:"newSection"},[_c('td',{staticClass:"text-center",attrs:{"colspan":"4"}},[_vm._v("\n                "+_vm._s(tenant.bezeichnung || "")+"\n              ")])]),_c('ComparableTableRow',{key:index + '_' + tenant.id + '_publicationDate',attrs:{"order":26 + index * 7,"tenant":tenant.id,"text1":_vm.formatDate(
                  _vm.getPublicationProperty(
                    _vm.ContractOne.PublicationInfo,
                    tenant.id,
                    'publicationDate',
                  ),
                ) || '',"text2":_vm.formatDate(
                  _vm.getPublicationProperty(
                    _vm.ContractTwo.PublicationInfo,
                    tenant.id,
                    'publicationDate',
                  ),
                ) || '',"title":"Publikationsdatum"},on:{"comparisonFinished":(comparison) => {
                  _vm.addComparison(comparison);
                }}}),_c('ComparableTableRow',{key:index + '_' + tenant.id + '_validFrom',attrs:{"order":27 + index * 7,"tenant":tenant.id,"text1":_vm.formatDate(
                  _vm.getPublicationProperty(
                    _vm.ContractOne.PublicationInfo,
                    tenant.id,
                    'validFrom',
                  ),
                ),"text2":_vm.formatDate(
                  _vm.getPublicationProperty(
                    _vm.ContractTwo.PublicationInfo,
                    tenant.id,
                    'validFrom',
                  ),
                ),"title":"Gültig ab"},on:{"comparisonFinished":(comparison) => {
                  _vm.addComparison(comparison);
                }}}),_c('ComparableTableRow',{key:index + '_' + tenant.id + '_validTo',attrs:{"order":28 + index * 7,"tenant":tenant.id,"text1":_vm.getPublicationContentProperty(
                  _vm.ContractOne.PublicationInfo,
                  tenant.id,
                  'value',
                  _vm.selectedLanguage,
                ),"text2":_vm.getPublicationContentProperty(
                  _vm.ContractTwo.PublicationInfo,
                  tenant.id,
                  'value',
                  _vm.selectedLanguage,
                ),"title":"Anzeigename"},on:{"comparisonFinished":(comparison) => {
                  _vm.addComparison(comparison);
                }}}),_c('ComparableTableRow',{key:index + '_' + tenant.id + '_shortName',attrs:{"order":29 + index * 7,"tenant":tenant.id,"text1":_vm.getPublicationContentProperty(
                  _vm.ContractOne.PublicationInfo,
                  tenant.id,
                  'shortName',
                  _vm.selectedLanguage,
                ),"text2":_vm.getPublicationContentProperty(
                  _vm.ContractTwo.PublicationInfo,
                  tenant.id,
                  'shortName',
                  _vm.selectedLanguage,
                ),"title":"Kurzname Tenant"},on:{"comparisonFinished":(comparison) => {
                  _vm.addComparison(comparison);
                }}}),_c('ComparableTableRow',{key:index + '_' + tenant.id + '_comment',attrs:{"order":30 + index * 7,"tenant":tenant.id,"text1":_vm.getPublicationContentProperty(
                  _vm.ContractOne.PublicationInfo,
                  tenant.id,
                  'comment',
                  _vm.selectedLanguage,
                ),"text2":_vm.getPublicationContentProperty(
                  _vm.ContractTwo.PublicationInfo,
                  tenant.id,
                  'comment',
                  _vm.selectedLanguage,
                ),"title":"Kommentar"},on:{"comparisonFinished":(comparison) => {
                  _vm.addComparison(comparison);
                }}}),_c('ComparableTableRow',{key:index + '_' + tenant.id + '_news',attrs:{"order":31 + index * 7,"tenant":tenant.id,"text1":_vm.getPublicationContentProperty(
                  _vm.ContractOne.PublicationInfo,
                  tenant.id,
                  'news',
                  _vm.selectedLanguage,
                ),"text2":_vm.getPublicationContentProperty(
                  _vm.ContractTwo.PublicationInfo,
                  tenant.id,
                  'news',
                  _vm.selectedLanguage,
                ),"title":"Was ist neu"},on:{"comparisonFinished":(comparison) => {
                  _vm.addComparison(comparison);
                }}}),_c('ComparableTableRow',{key:index + '_' + tenant.id + '_rssFeed',attrs:{"order":32 + index * 7,"tenant":tenant.id,"text1":_vm.getPublicationContentProperty(
                  _vm.ContractOne.PublicationInfo,
                  tenant.id,
                  'rssFeed',
                  _vm.selectedLanguage,
                ),"text2":_vm.getPublicationContentProperty(
                  _vm.ContractTwo.PublicationInfo,
                  tenant.id,
                  'rssFeed',
                  _vm.selectedLanguage,
                ),"title":"RSS-Feed"},on:{"comparisonFinished":(comparison) => {
                  _vm.addComparison(comparison);
                }}})]:_vm._e()]})],2)]),(_vm.storedPdf)?_c('button',{staticClass:"d-block",on:{"click":function($event){_vm.storedPdf.download(
          `${_vm.ContractOne.EditionInfo.id.toString()}_${_vm.ContractTwo.EditionInfo.id.toString()}_${_vm.$moment(
            new Date(),
          ).format('YYYYMMDD')}.pdf`,
        )}}},[_c('i',{staticClass:"fas fa-file-pdf"}),_vm._v(" Vergleich als PDF speichern\n    ")]):_vm._e(),(_vm.storedPdf)?_c('button',{staticClass:"d-block",on:{"click":function($event){_vm.downloadCsv(
          `${_vm.ContractOne.EditionInfo.id.toString()}_${_vm.ContractTwo.EditionInfo.id.toString()}_${_vm.$moment(
            new Date(),
          ).format('YYYYMMDD')}.csv`,
        )}}},[_c('i',{staticClass:"fas fa-file-csv"}),_vm._v(" Vergleich als CSV speichern\n    ")]):_vm._e(),_c('div',{staticClass:"w-100",staticStyle:{"height":"30px"}},[(_vm.storedPdf)?_c('v-select',{staticClass:"w-25 mb-4 float-right",attrs:{"items":_vm.languages,"item-text":"label","item-value":"language"},model:{value:(_vm.selectedLanguage),callback:function ($$v) {_vm.selectedLanguage=$$v},expression:"selectedLanguage"}}):_vm._e()],1),(_vm.allContractInfosLoaded)?_c('CompareCriterions',{attrs:{"contract-one-information":{
        contractId: _vm.ContractOne.ContractInfo.contractNumber, // Make sure this is populated
        versionId: _vm.ContractOne.VersionInfo.number.toString(),
        editionId: _vm.ContractOne.EditionInfo.id,
      },"contract-one-short-name":_vm.getContentByLanguage(
          _vm.ContractOne.VersionInfo.versionContents,
          'nameShort',
          _vm.selectedLanguage,
          true,
        ),"contract-two-information":{
        contractId: _vm.ContractTwo.ContractInfo.contractNumber,
        versionId: _vm.ContractTwo.VersionInfo.number.toString(),
        editionId: _vm.ContractTwo.EditionInfo.id,
      },"contract-two-short-name":_vm.getContentByLanguage(
          _vm.ContractTwo.VersionInfo.versionContents,
          'nameShort',
          _vm.selectedLanguage,
          true,
        ),"selected-language":_vm.selectedLanguage},on:{"criterionsLoaded":_vm.criterionsLoaded}}):_vm._e(),(_vm.storedPdf)?_c('button',{staticClass:"d-block",on:{"click":function($event){_vm.storedPdf.download(
          `${_vm.ContractOne.EditionInfo.id.toString()}_${_vm.ContractTwo.EditionInfo.id.toString()}_${_vm.$moment(
            new Date(),
          ).format('YYYYMMDD')}.pdf`,
        )}}},[_c('i',{staticClass:"fas fa-file-pdf"}),_vm._v(" Vergleich als PDF speichern\n    ")]):_vm._e(),(_vm.storedPdf)?_c('button',{staticClass:"d-block",on:{"click":function($event){_vm.downloadCsv(
          `${_vm.ContractOne.EditionInfo.id.toString()}_${_vm.ContractTwo.EditionInfo.id.toString()}_${_vm.$moment(
            new Date(),
          ).format('YYYYMMDD')}.csv`,
        )}}},[_c('i',{staticClass:"fas fa-file-csv"}),_vm._v(" Vergleich als CSV speichern\n    ")]):_vm._e()],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }